export default __webpack_public_path__ + "static/media/medway-watermark-mensageiros.68fe5627.png";